import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { formatPrice } from "../../../../helpers/formatPrice.tsx";
import { useAppSelector } from "../../../../services/hooks.ts";
import AnimateNumber from "../../Motion/AnimateNumber.tsx";
import { roundToTwo } from "../../../../helpers/roundToTwo.tsx";
import { useTranslation } from "react-i18next";

export default function SiteSummaryProducts() {
    const cartValue = useAppSelector((state) => state.cart.value);
    const cartValueGross = useAppSelector((state) => state.cart.valueGross);
    const currency = useAppSelector((state) => state.user.currency);
    const { t } = useTranslation('cart');

    return (
        <AnimateNumber KEY={cartValue}>
            <Row className="pt-2">
                <Col>
                    <strong>{t('summary.product_value')}:</strong>
                </Col>
                <Col className="text-end">
                    {formatPrice(roundToTwo(cartValueGross / 100), currency)} {t('products.gross_price')}<br />
                    <small>{formatPrice(roundToTwo(cartValue / 100), currency)} {t('products.net_price')}</small>
                </Col>
            </Row>
        </AnimateNumber>
    )
}